import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccCheckoutAdapter } from '@spartacus/checkout/base/occ';
import { Observable } from 'rxjs';
import { CustomRealtimeStockAdapter } from "../conectors/custom-realtime-stock.adapter";

@Injectable()
export class CustomOccRealtimeStockAdapter extends OccCheckoutAdapter implements CustomRealtimeStockAdapter {

  public simulateOrder(
    userId: string,
    cartId: string
  ): Observable<any> {
    const url = this.occEndpoints.buildUrl('simulate', { urlParams: { userId, cartId } });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.put<any>(url, { headers });
  }

  public realStock(
    userId: string,
    cartId: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.occEndpoints.buildUrl('validateRealtimeStock', { urlParams: { userId, cartId } });
    return this.http.get(url, { headers });
  }

  public modifiedProduct(
    userId: string,
    cartId: string
  ): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.occEndpoints.buildUrl('getModifiedProducts', { urlParams: { userId, cartId } });
    return this.http.get(url, { headers });
  }
}
